// We importeren React en de useState-hook om waarden op te slaan binnen deze component
import React, { useState } from "react";
// We importeren de CSS-styling voor de login- en registratiepagina
import "./styles/auth.css";

// Dit is de Register-component
// - onRegistered → functie die aangeroepen wordt als registratie is gelukt
// - onSwitchToLogin → om terug te gaan naar de loginpagina
export default function Register({ onRegistered, onSwitchToLogin }) {
  // 🔹 useState: hiermee onthouden we wat de gebruiker invult in het formulier
  const [gebruiksnaam, setGebruiksnaam] = useState(""); // bewaart de ingevoerde gebruikersnaam
  const [email, setEmail] = useState(""); // bewaart het ingevoerde e-mailadres
  const [wachtwoord, setWachtwoord] = useState(""); // bewaart het ingevoerde wachtwoord
  const [error, setError] = useState(""); // toont foutmeldingen als er iets misgaat
  const [success, setSuccess] = useState(""); // toont een succesbericht na succesvolle registratie

  // 🔹 Deze functie wordt uitgevoerd wanneer het formulier wordt verzonden (submit)
  const handleRegister = async (e) => {
    e.preventDefault(); // voorkomt dat de pagina opnieuw laadt
    setError(""); // reset de foutmelding
    setSuccess(""); // reset het succesbericht

    try {
      // Verstuur de gegevens naar de backend (PHP) via een POST-request
      const res = await fetch("http://localhost/backend/api/register.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" }, // de inhoud is JSON
        body: JSON.stringify({ gebruiksnaam, email, wachtwoord }), // stuur de data van het formulier mee
      });

      // Ontvang de JSON-respons van de server
      const data = await res.json();

      // Als de registratie succesvol was
      if (data.status === "success") {
        setSuccess("Registratie gelukt! Je kunt nu inloggen."); // toon succesbericht
        // Wacht 1,5 seconde en ga dan automatisch terug naar de loginpagina
        setTimeout(() => onRegistered(), 1500);
      } else {
        // Als de backend een foutmelding geeft
        setError(data.message || "Er is iets misgegaan");
      }
    } catch (err) {
      // Als er iets misgaat met de verbinding of server
      setError("Serverfout: " + err.message);
    }
  };

  // 🔹 De return bepaalt wat de gebruiker in de browser ziet (HTML-structuur)
  return (
    <div className="auth-page">
      {/* Het formulier voor het aanmaken van een nieuw account */}
      <form onSubmit={handleRegister} className="auth-card">
        <h2 className="auth-title">Account aanmaken</h2>

        {/* Veld voor gebruikersnaam */}
        <div className="auth-row">
          <label className="auth-label">Gebruikersnaam</label>
          <input
            type="text"
            value={gebruiksnaam} // koppel het invoerveld aan de state
            onChange={(e) => setGebruiksnaam(e.target.value)} // update de state bij elke toetsaanslag
            className="auth-input"
            required // verplicht veld
          />
        </div>

        {/* Veld voor e-mailadres */}
        <div className="auth-row">
          <label className="auth-label">E-mail</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="auth-input"
            required
          />
        </div>

        {/* Veld voor wachtwoord */}
        <div className="auth-row">
          <label className="auth-label">Wachtwoord</label>
          <input
            type="password"
            value={wachtwoord}
            onChange={(e) => setWachtwoord(e.target.value)}
            className="auth-input"
            required
          />
        </div>

        {/* De knop om het formulier te verzenden */}
        <div className="auth-actions">
          <button type="submit" className="auth-btn auth-btn--primary">
            Aanmelden
          </button>
        </div>

        {/* Als er iets misgaat, tonen we een foutmelding */}
        {error && <div className="auth-message auth-message--error">{error}</div>}

        {/* Als de registratie lukt, tonen we een succesbericht */}
        {success && (
          <div className="auth-message auth-message--success">{success}</div>
        )}

        {/* Link om terug te gaan naar het login-scherm */}
        <div className="auth-toggle">
          Heb je al een account?{" "}
          <button type="button" onClick={onSwitchToLogin}>
            Log in
          </button>
        </div>
      </form>
    </div>
  );
}
